export const COLLECTIONS = {
  insights: {
    key: "insights",
    label: "Market Insights",
    singular: "Insight",
    route: "/cms/insights",
    statusField: "published",
    statusType: "boolean",
    publishedValue: true,
    draftValue: false,
    hasPdf: true,
    hasAuthor: false,
    hasSeo: true,
    heroField: "image",
  },
  blogs: {
    key: "blogs",
    label: "Blogs",
    singular: "Blog",
    route: "/cms/blogs",
    statusField: "status",
    statusType: "string",
    publishedValue: "published",
    draftValue: "draft",
    hasPdf: false,
    hasAuthor: true,
    hasSeo: true,
    heroField: "coverPhoto",
  },
  news: {
    key: "news",
    label: "News",
    singular: "News Article",
    route: "/cms/news",
    statusField: "status",
    statusType: "string",
    publishedValue: "published",
    draftValue: "draft",
    hasPdf: false,
    hasAuthor: true,
    hasSeo: true,
    heroField: "coverPhoto",
  },
  // Careers reuse the blog/news status convention so the "Refresh
  // public site" flow works out of the box. The form fields differ
  // (department, employmentType, applyEmail, etc.) so the CMS pages
  // don't share ArticleForm — see CareersList / CareerForm.
  careers: {
    key: "careers",
    label: "Careers",
    singular: "Job Posting",
    route: "/cms/careers",
    statusField: "status",
    statusType: "string",
    publishedValue: "published",
    draftValue: "draft",
    hasPdf: false,
    hasAuthor: false,
    hasSeo: true,
    heroField: null,
    // Careers use `postedAt` (the "when did we publish this job" date)
    // instead of the blog/news `date`. paginatedQuery.js uses this
    // when ordering the CMS list.
    orderByField: "postedAt",
  },
  leaders: {
    key: "leaders",
    label: "Executive Leadership",
    singular: "Leader",
    route: "/cms/leadership",
    statusField: "status",
    statusType: "string",
    publishedValue: "published",
    draftValue: "draft",
    hasPdf: false,
    hasAuthor: false,
    hasSeo: true,
    // Leaders use the photo as the hero image — ContentCard shows it
    // as the top thumbnail.
    heroField: "photoUrl",
    // Portrait crop, top-anchored — mirrors how the public
    // /executive-leadership grid renders the same photos, so the
    // CMS thumbnail is instantly recognizable as the same person.
    heroAspect: "square",
    heroObjectPosition: "center top",
    // Leaders are ordered manually via `sortOrder` (an integer, not
    // a date). `dateField: null` tells ContentCard NOT to render a
    // date row — without this override the shared card would call
    // formatDate(sortOrder) and print "Jan 1, 1970".
    orderByField: "sortOrder",
    dateField: null,
  },
  // Brokers appear only in the About Us slideshow on the public site.
  // No detail page, no rich bio, no SEO — just name + photo + ordering.
  // Same status / hero / ordering conventions as leaders so the shared
  // ContentListGrid + ContentCard renderers work with zero branching.
  brokers: {
    key: "brokers",
    label: "Brokers",
    singular: "Broker",
    route: "/cms/brokers",
    statusField: "status",
    statusType: "string",
    publishedValue: "published",
    draftValue: "draft",
    hasPdf: false,
    hasAuthor: false,
    hasSeo: false,
    heroField: "photoUrl",
    // Match the public slideshow's crop so CMS thumbnails read as
    // portraits, not center-cropped headless shots.
    heroAspect: "square",
    heroObjectPosition: "center top",
    orderByField: "sortOrder",
    dateField: null,
  },
};

export function isPublished(doc, schema) {
  if (!doc || !schema) return false;
  return doc[schema.statusField] === schema.publishedValue;
}

export function setPublishStatus(target, schema, published) {
  target[schema.statusField] = published ? schema.publishedValue : schema.draftValue;
  return target;
}

export function storagePath({ collection, docId, kind, filename }) {
  return `cms/${collection}/${docId}/${kind}/${filename}`;
}
